// extracted by mini-css-extract-plugin
export default {"content":"styles_content__V0TZ8","spinner":"styles_spinner__5MUBq"};